module.exports = __webpack_public_path__ + "img/1ZsoxXzj_eSaMuK5-U9L4r-iq37bYu5-C.0bc78b89.jpg";